import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectPage"]
  static values = {
    turboStream: Boolean
  }

  connect() {
    this.selectPageTarget.addEventListener('change', this.handlePageChange.bind(this))
  }

  handlePageChange(event) {
    const currentPath = window.location.pathname
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('page', event.target.value)

    if (this.turboStreamValue) {
      searchParams.set('format', 'turbo_stream')

      const url = `${currentPath}?${searchParams.toString()}`
      fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        }
      }).then(response => response.text())
        .then(html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, "text/html")
          const turboParts = doc.querySelectorAll('turbo-stream')
          turboParts.forEach(part => {
            Turbo.renderStreamMessage(part.outerHTML)
          })

          const newUrl = `${currentPath}?${new URLSearchParams(window.location.search).set('page', event.target.value)}`
          window.history.pushState({}, '', newUrl)
        })
    } else {
      window.location.href = `${currentPath}?${searchParams.toString()}`
    }
  }
}